// export default class GalleryTool {
//   static get toolbox() {
//     return {
//       title: "Gallery",
//       icon: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>`,
//     };
//   }

//   static get isReadOnlySupported() {
//     return true;
//   }
//   static get tunes() {
//     return [];
//   }

//   constructor({ data, config, api }) {
//     this.api = api;
//     this.config = config || {};
//     this.data = {
//       files: data.files || [],
//       cols: data.cols || 3,
//       rows: data.rows || 0,
//       style: data.style || "slider",
//       caption: data.caption || "",
//     };
//     this._wrapper = null;
//     this._gridEl = null;
//     this._colsSel = null;
//     this._rowsSel = null;
//   }

//   render() {
//     this._wrapper = document.createElement("div");
//     this._injectStyles();
//     this._buildUI();
//     return this._wrapper;
//   }

//   _injectStyles() {
//     if (document.getElementById("gallery-tool-styles")) return;
//     const style = document.createElement("style");
//     style.id = "gallery-tool-styles";
//     style.textContent = `
//       .gt-wrap {
//         font-family: -apple-system,
//         BlinkMacSystemFont, 'Segoe UI', sans-serif;
//         margin-bottom: 20px
//       }

//       .gt-toolbar {
//         display: flex;
//         align-items: center;
//         gap: 6px;
//         padding: 6px 10px;
//         background: #f8f8f8;
//         border: 1px solid #e8e8e8;
//         border-radius: 3px 3px 0 0;
//         flex-wrap: wrap;
//       }

//       .gt-seg {
//         display: flex;
//         background: #efefef;
//         border-radius: 7px;
//         padding: 2px;
//         gap: 2px;
//       }
//       .gt-seg button {
//         border: none;
//         background: transparent;
//         padding: 4px 12px;
//         border-radius: 5px;
//         font-size: 12px;
//         font-weight: 500;
//         color: #666;
//         cursor: pointer;
//         transition: all .15s;
//         white-space: nowrap;
//       }
//       .gt-seg button.active {
//         background: #fff;
//         color: #111;
//         box-shadow: 0 1px 3px rgba(0,0,0,.12);
//       }

//       .gt-divider {
//         width: 1px;
//         height: 22px;
//         background: #ddd;
//         flex-shrink: 0;
//       }

//       .gt-control {
//         display: flex;
//         align-items: center;
//         gap: 5px;
//         font-size: 12px;
//         color: #555;
//         transition: opacity .2s;
//       }
//       .gt-control span { white-space: nowrap; }
//       .gt-control select {
//         border: 1px solid #ddd;
//         border-radius: 6px;
//         padding: 3px 6px;
//         font-size: 12px;
//         background: #fff;
//         color: #333;
//         cursor: pointer;
//         outline: none;
//         transition: border-color .15s;
//       }
//       .gt-control select:focus { border-color: #999; }
//       .gt-control.disabled { opacity: 0.35; pointer-events: none; }

//       .gt-add-btn {
//         margin-left: auto;
//         display: flex;
//         align-items: center;
//         gap: 5px;
//         padding: 5px 12px;
//         border: 1.5px dashed #ccc;
//         border-radius: 7px;
//         background: #fff;
//         color: #555;
//         font-size: 12px;
//         font-weight: 500;
//         cursor: pointer;
//         transition: all .15s;
//         white-space: nowrap;
//       }
//       .gt-add-btn:hover { border-color: #888; color: #222; background: #f5f5f5; }

//       .gt-caption,
// .gt-link {
//   width: 100%;
//   border: none;
//   border-top: 1px solid #eee;
//   padding: 6px;
//   font-size: 12px;
//   outline: none;
// }

//       .gt-grid-wrap {
//         border: 1px solid #e8e8e8;
//         border-top: none;
//         border-radius: 0 0 3px 3px;
//         overflow: hidden;
//         background: #fafafa;
//       }

//       .gt-empty {
//         display: flex;
//         flex-direction: column;
//         align-items: center;
//         justify-content: center;
//         gap: 8px;
//         padding: 40px 20px;
//         color: #bbb;
//         font-size: 13px;
//       }
//       .gt-empty svg { opacity: .4; }

//       .gt-grid {
//         display: grid;
//         gap: 3px;
//         padding: 3px;
//       }

//       .gt-cell {
//         position: relative;
//         overflow: hidden;
//         border-radius: 6px;
//         background: #e8e8e8;
//         cursor: pointer;
//       }
//       .gt-cell img {
//         width: 100%;
//         height: 150px;
//         object-fit: cover;
//         display: block;
//         transition: transform .2s;
//       }
//       .gt-cell:hover img { transform: scale(1.03); }

//       .gt-cell-overlay {
//         position: absolute;
//         inset: 0;
//         background: rgba(0,0,0,0);
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         transition: background .2s;
//       }
//       .gt-cell:hover .gt-cell-overlay { background: rgba(0,0,0,.3); }

//       .gt-del-btn {
//         opacity: 0;
//         width: 28px;
//         height: 28px;
//         border-radius: 50%;
//         border: none;
//         background: rgba(255,255,255,.95);
//         color: #e53e3e;
//         font-size: 14px;
//         cursor: pointer;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         transition: opacity .15s, transform .15s;
//         transform: scale(.8);
//         box-shadow: 0 1px 4px rgba(0,0,0,.2);
//       }
//       .gt-cell:hover .gt-del-btn { opacity: 1; transform: scale(1); }

//       .gt-more {
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         height: 150px;
//         border-radius: 6px;
//         background: #ececec;
//         color: #666;
//         font-size: 18px;
//         font-weight: 600;
//         letter-spacing: -.5px;
//       }
//     `;
//     document.head.appendChild(style);
//   }

//   _buildUI() {
//     this._wrapper.innerHTML = "";
//     this._wrapper.className = "gt-wrap";

//     // ── Toolbar ─────────────────────────────────────────────────────────────
//     const toolbar = document.createElement("div");
//     toolbar.className = "gt-toolbar";

//     // Style segmented control
//     const styleSeg = this._segmented(
//       ["slider", "fit"],
//       ["Slider", "Grid"],
//       this.data.style,
//       (v) => {
//         this.data.style = v;
//         this._toggleGridControls();
//         this._renderGrid();
//       },
//     );
//     toolbar.appendChild(styleSeg);

//     toolbar.appendChild(this._divider());

//     // Cols
//     const colsWrap = this._control(
//       "Багана",
//       [1, 2, 3, 4],
//       this.data.cols,
//       (v) => {
//         this.data.cols = +v;
//         this._renderGrid();
//       },
//     );
//     this._colsSel = colsWrap.querySelector("select");

//     // Rows
//     const rowsWrap = this._control(
//       "Мөр",
//       [0, 1, 2, 3, 4, 5],
//       this.data.rows,
//       (v) => {
//         this.data.rows = +v;
//         this._renderGrid();
//       },
//     );
//     this._rowsSel = rowsWrap.querySelector("select");

//     toolbar.appendChild(colsWrap);
//     toolbar.appendChild(rowsWrap);

//     // Add button
//     const addBtn = document.createElement("button");
//     addBtn.className = "gt-add-btn";
//     addBtn.type = "button";
//     addBtn.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg> Зураг нэмэх`;
//     addBtn.addEventListener("click", () => this._pickFiles());
//     toolbar.appendChild(addBtn);

//     this._wrapper.appendChild(toolbar);

//     // ── Grid wrap ────────────────────────────────────────────────────────────
//     const gridWrap = document.createElement("div");
//     gridWrap.className = "gt-grid-wrap";
//     this._gridEl = gridWrap;
//     this._wrapper.appendChild(gridWrap);

//     this._toggleGridControls();
//     this._renderGrid();
//   }

//   _segmented(values, labels, current, onChange) {
//     const wrap = document.createElement("div");
//     wrap.className = "gt-seg";

//     values.forEach((v, i) => {
//       const btn = document.createElement("button");
//       btn.type = "button";
//       btn.textContent = labels[i];
//       if (String(v) === String(current)) btn.classList.add("active");
//       btn.addEventListener("click", () => {
//         wrap
//           .querySelectorAll("button")
//           .forEach((b) => b.classList.remove("active"));
//         btn.classList.add("active");
//         onChange(v);
//       });
//       wrap.appendChild(btn);
//     });
//     return wrap;
//   }

//   _control(label, options, current, onChange) {
//     const wrap = document.createElement("div");
//     wrap.className = "gt-control";

//     const span = document.createElement("span");
//     span.textContent = label + ":";
//     wrap.appendChild(span);

//     const sel = document.createElement("select");
//     options.forEach((o) => {
//       const opt = document.createElement("option");
//       opt.value = o;
//       opt.textContent = o === 0 ? "авто" : o;
//       if (String(o) === String(current)) opt.selected = true;
//       sel.appendChild(opt);
//     });
//     sel.addEventListener("change", (e) => onChange(e.target.value));
//     wrap.appendChild(sel);
//     return wrap;
//   }

//   _divider() {
//     const d = document.createElement("div");
//     d.className = "gt-divider";
//     return d;
//   }

//   _toggleGridControls() {
//     const isFit = this.data.style === "fit";
//     [this._colsSel?.parentElement, this._rowsSel?.parentElement].forEach(
//       (el) => {
//         if (!el) return;
//         el.classList.toggle("disabled", !isFit);
//       },
//     );
//   }

//   _renderGrid() {
//     if (!this._gridEl) return;
//     this._gridEl.innerHTML = "";

//     if (!this.data.files.length) {
//       const empty = document.createElement("div");
//       empty.className = "gt-empty";
//       empty.innerHTML = `
//         <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
//           <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
//           <polyline points="21 15 16 10 5 21"/>
//         </svg>
//         <span>Зураг нэмээгүй байна</span>`;
//       this._gridEl.appendChild(empty);
//       return;
//     }

//     const cols = this.data.cols || 3;
//     const maxVisible =
//       this.data.rows > 0 ? cols * this.data.rows : this.data.files.length;
//     const visible = this.data.files.slice(0, maxVisible);
//     const hidden = this.data.files.length - visible.length;

//     const grid = document.createElement("div");
//     grid.className = "gt-grid";
//     grid.style.gridTemplateColumns = `repeat(${cols}, 1fr)`;

//     // visible.forEach((file, idx) => {
//     //   const cell = document.createElement("div");
//     //   cell.className = "gt-cell";

//     //   const img = document.createElement("img");
//     //   img.src = file.url;

//     //   const overlay = document.createElement("div");
//     //   overlay.className = "gt-cell-overlay";

//     //   const del = document.createElement("button");
//     //   del.className = "gt-del-btn";
//     //   del.type = "button";
//     //   del.innerHTML = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
//     //   del.addEventListener("click", (e) => {
//     //     e.stopPropagation();
//     //     this.data.files.splice(idx, 1);
//     //     this._renderGrid();
//     //   });

//     //   overlay.appendChild(del);
//     //   cell.appendChild(img);
//     //   cell.appendChild(overlay);
//     //   grid.appendChild(cell);
//     // });
//     visible.forEach((file, idx) => {
//       const cell = document.createElement("div");
//       cell.className = "gt-cell";

//       const img = document.createElement("img");
//       img.src = file.url;

//       // 👉 LINK CLICK
//       img.addEventListener("click", () => {
//         if (file.link) {
//           window.open(file.link, "_blank");
//         }
//       });

//       // 👉 CAPTION INPUT
//       const captionInput = document.createElement("input");
//       captionInput.placeholder = "Caption...";
//       captionInput.value = file.caption || "";
//       captionInput.className = "gt-caption";
//       captionInput.addEventListener("input", (e) => {
//         this.data.files[idx].caption = e.target.value;
//       });

//       // 👉 LINK INPUT
//       const linkInput = document.createElement("input");
//       linkInput.placeholder = "https://...";
//       linkInput.value = file.link || "";
//       linkInput.className = "gt-link";
//       linkInput.addEventListener("input", (e) => {
//         this.data.files[idx].link = e.target.value;
//       });

//       const overlay = document.createElement("div");
//       overlay.className = "gt-cell-overlay";

//       const del = document.createElement("button");
//       del.className = "gt-del-btn";
//       del.type = "button";
//       del.innerHTML = `✕`;

//       del.addEventListener("click", (e) => {
//         e.stopPropagation();
//         this.data.files.splice(idx, 1);
//         this._renderGrid();
//       });

//       overlay.appendChild(del);

//       cell.appendChild(img);
//       cell.appendChild(overlay);
//       cell.appendChild(captionInput);
//       cell.appendChild(linkInput);

//       grid.appendChild(cell);
//     });

//     if (hidden > 0) {
//       const more = document.createElement("div");
//       more.className = "gt-more";
//       more.textContent = `+${hidden}`;
//       grid.appendChild(more);
//     }

//     this._gridEl.appendChild(grid);
//   }

//   _pickFiles() {
//     const input = document.createElement("input");
//     input.type = "file";
//     input.multiple = true;
//     input.accept = "image/*";
//     input.addEventListener("change", async () => {
//       for (const file of Array.from(input.files)) {
//         const result = await this.config.uploader.uploadByFile(file);
//         if (result.success)
//           this.data.files.push({ url: result.file.url, caption: "", link: "" });
//       }
//       this._renderGrid();
//     });
//     input.click();
//   }

//   save() {
//     return {
//       files: this.data.files,
//       cols: this.data.cols,
//       rows: this.data.rows,
//       style: this.data.style,
//       caption: this.data.caption,
//     };
//   }

//   static validate(data) {
//     return Array.isArray(data.files) && data.files.length > 0;
//   }
// }

export default class GalleryTool {
  static get toolbox() {
    return {
      title: "Gallery",
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>`,
    };
  }

  static get isReadOnlySupported() {
    return true;
  }
  static get tunes() {
    return [];
  }

  constructor({ data, config, api }) {
    this.api = api;
    this.config = config || {};
    this.data = {
      files: (data.files || []).map((f) => ({
        url: f.url || "",
        caption: f.caption || "",
        link: f.link || "",
      })),
      cols: data.cols || 3,
      rows: data.rows || 0,
      style: data.style || "slider",
      caption: data.caption || "",
    };
    this._wrapper = null;
    this._gridEl = null;
    this._colsSel = null;
    this._rowsSel = null;
  }

  render() {
    this._wrapper = document.createElement("div");
    this._injectStyles();
    this._buildUI();
    return this._wrapper;
  }

  _injectStyles() {
    if (document.getElementById("gallery-tool-styles")) return;
    const style = document.createElement("style");
    style.id = "gallery-tool-styles";
    style.textContent = `
      .gt-wrap { 
        font-family: -apple-system, 
        BlinkMacSystemFont, 'Segoe UI', sans-serif; 
        margin-bottom: 20px 
      }

      .gt-toolbar {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 6px 10px;
        background: #f8f8f8;
        border: 1px solid #e8e8e8;
        border-radius: 3px 3px 0 0;
        flex-wrap: wrap;
      }

      .gt-seg {
        display: flex;
        background: #efefef;
        border-radius: 7px;
        padding: 2px;
        gap: 2px;
      }
      .gt-seg button {
        border: none;
        background: transparent;
        padding: 4px 12px;
        border-radius: 5px;
        font-size: 12px;
        font-weight: 500;
        color: #666;
        cursor: pointer;
        transition: all .15s;
        white-space: nowrap;
      }
      .gt-seg button.active {
        background: #fff;
        color: #111;
        box-shadow: 0 1px 3px rgba(0,0,0,.12);
      }

      .gt-divider {
        width: 1px;
        height: 22px;
        background: #ddd;
        flex-shrink: 0;
      }

      .gt-control {
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 12px;
        color: #555;
        transition: opacity .2s;
      }
      .gt-control span { white-space: nowrap; }
      .gt-control select {
        border: 1px solid #ddd;
        border-radius: 6px;
        padding: 3px 6px;
        font-size: 12px;
        background: #fff;
        color: #333;
        cursor: pointer;
        outline: none;
        transition: border-color .15s;
      }
      .gt-control select:focus { border-color: #999; }
      .gt-control.disabled { opacity: 0.35; pointer-events: none; }

      .gt-add-btn {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 5px 12px;
        border: 1.5px dashed #ccc;
        border-radius: 7px;
        background: #fff;
        color: #555;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
        transition: all .15s;
        white-space: nowrap;
      }
      .gt-add-btn:hover { border-color: #888; color: #222; background: #f5f5f5; }

      .gt-grid-wrap {
        border: 1px solid #e8e8e8;
        border-top: none;
        border-radius: 0 0 3px 3px;
        overflow: hidden;
        background: #fafafa;
      }

      .gt-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 40px 20px;
        color: #bbb;
        font-size: 13px;
      }
      .gt-empty svg { opacity: .4; }

      .gt-grid {
        display: grid;
        gap: 3px;
        padding: 3px;
      }

      .gt-cell {
        position: relative;
        overflow: hidden;
        border-radius: 6px;
        background: #e8e8e8;
        cursor: pointer;
      }
      .gt-cell img {
        width: 100%;
        height: 150px;
        object-fit: cover;
        display: block;
        transition: transform .2s;
        border: 1.5px solid rgba(0, 0, 0, 0.08);
        border-radius: 6px;
        box-sizing: border-box;
      }
      .gt-cell:hover img { transform: scale(1.03); }

      .gt-cell-overlay {
        position: absolute;
        inset: 0;
        background: rgba(0,0,0,0);
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        padding: 6px;
        gap: 4px;
        transition: background .2s;
      }
      .gt-cell:hover .gt-cell-overlay { background: rgba(0,0,0,.3); }

      .gt-overlay-btn {
        opacity: 0;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        border: none;
        background: rgba(255,255,255,.95);
        font-size: 14px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity .15s, transform .15s;
        transform: scale(.8);
        box-shadow: 0 1px 4px rgba(0,0,0,.2);
      }
      .gt-overlay-btn.gt-edit-btn { color: #3182ce; }
      .gt-overlay-btn.gt-del-btn { color: #e53e3e; }
      .gt-cell:hover .gt-overlay-btn { opacity: 1; transform: scale(1); }

      .gt-cell-caption {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 20px 8px 6px;
        background: linear-gradient(transparent, rgba(0,0,0,.55));
        color: #fff;
        font-size: 11px;
        line-height: 1.3;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        pointer-events: none;
      }

      .gt-cell-link-icon {
        position: absolute;
        bottom: 6px;
        right: 6px;
        width: 18px;
        height: 18px;
        background: rgba(255,255,255,.85);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        box-shadow: 0 1px 3px rgba(0,0,0,.15);
      }

      .gt-more {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 150px;
        border-radius: 6px;
        background: #ececec;
        color: #666;
        font-size: 18px;
        font-weight: 600;
        letter-spacing: -.5px;
      }

      /* ── Modal ────────────────────────────────────────── */
      .gt-modal-backdrop {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,.45);
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: gt-fade-in .15s ease;
      }
      @keyframes gt-fade-in { from { opacity: 0; } to { opacity: 1; } }

      .gt-modal {
        background: #fff;
        border-radius: 12px;
        width: 380px;
        max-width: 90vw;
        box-shadow: 0 20px 60px rgba(0,0,0,.25);
        overflow: hidden;
        animation: gt-slide-up .2s ease;
      }
      @keyframes gt-slide-up { from { transform: translateY(12px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

      .gt-modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 18px;
        border-bottom: 1px solid #eee;
        font-size: 14px;
        font-weight: 600;
        color: #222;
      }
      .gt-modal-close {
        background: none;
        border: none;
        cursor: pointer;
        color: #999;
        padding: 2px;
        display: flex;
        align-items: center;
      }
      .gt-modal-close:hover { color: #333; }

      .gt-modal-body {
        padding: 18px;
        display: flex;
        flex-direction: column;
        gap: 14px;
      }

      .gt-modal-field {
        display: flex;
        flex-direction: column;
        gap: 5px;
      }
      .gt-modal-field label {
        font-size: 12px;
        font-weight: 500;
        color: #555;
      }
      .gt-modal-field input {
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 8px 12px;
        font-size: 13px;
        outline: none;
        transition: border-color .15s;
        color: #222;
      }
      .gt-modal-field input:focus { border-color: #3182ce; }
      .gt-modal-field input::placeholder { color: #bbb; }

      .gt-modal-preview {
        width: 100%;
        max-height: 160px;
        object-fit: contain;
        border-radius: 8px;
        background: #f5f5f5;
        border: 1px solid rgba(0,0,0,.06);
      }

      .gt-modal-footer {
        padding: 12px 18px;
        border-top: 1px solid #eee;
        display: flex;
        justify-content: flex-end;
        gap: 8px;
      }
      .gt-modal-btn {
        padding: 7px 18px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        border: 1px solid #ddd;
        background: #fff;
        color: #555;
        transition: all .15s;
      }
      .gt-modal-btn:hover { background: #f5f5f5; }
      .gt-modal-btn.primary {
        background: #3182ce;
        color: #fff;
        border-color: #3182ce;
      }
      .gt-modal-btn.primary:hover { background: #2b6cb0; }
    `;
    document.head.appendChild(style);
  }

  _buildUI() {
    this._wrapper.innerHTML = "";
    this._wrapper.className = "gt-wrap";

    // ── Toolbar ──────────────────────────────────────────
    const toolbar = document.createElement("div");
    toolbar.className = "gt-toolbar";

    const styleSeg = this._segmented(
      ["slider", "fit"],
      ["Slider", "Grid"],
      this.data.style,
      (v) => {
        this.data.style = v;
        this._toggleGridControls();
        this._renderGrid();
      },
    );
    toolbar.appendChild(styleSeg);
    toolbar.appendChild(this._divider());

    const colsWrap = this._control(
      "Багана",
      [1, 2, 3, 4],
      this.data.cols,
      (v) => {
        this.data.cols = +v;
        this._renderGrid();
      },
    );
    this._colsSel = colsWrap.querySelector("select");

    const rowsWrap = this._control(
      "Мөр",
      [0, 1, 2, 3, 4, 5],
      this.data.rows,
      (v) => {
        this.data.rows = +v;
        this._renderGrid();
      },
    );
    this._rowsSel = rowsWrap.querySelector("select");

    toolbar.appendChild(colsWrap);
    toolbar.appendChild(rowsWrap);

    const addBtn = document.createElement("button");
    addBtn.className = "gt-add-btn";
    addBtn.type = "button";
    addBtn.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg> Зураг нэмэх`;
    addBtn.addEventListener("click", () => this._pickFiles());
    toolbar.appendChild(addBtn);

    this._wrapper.appendChild(toolbar);

    const gridWrap = document.createElement("div");
    gridWrap.className = "gt-grid-wrap";
    this._gridEl = gridWrap;
    this._wrapper.appendChild(gridWrap);

    this._toggleGridControls();
    this._renderGrid();
  }

  _segmented(values, labels, current, onChange) {
    const wrap = document.createElement("div");
    wrap.className = "gt-seg";
    values.forEach((v, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = labels[i];
      if (String(v) === String(current)) btn.classList.add("active");
      btn.addEventListener("click", () => {
        wrap
          .querySelectorAll("button")
          .forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        onChange(v);
      });
      wrap.appendChild(btn);
    });
    return wrap;
  }

  _control(label, options, current, onChange) {
    const wrap = document.createElement("div");
    wrap.className = "gt-control";
    const span = document.createElement("span");
    span.textContent = label + ":";
    wrap.appendChild(span);
    const sel = document.createElement("select");
    options.forEach((o) => {
      const opt = document.createElement("option");
      opt.value = o;
      opt.textContent = o === 0 ? "авто" : o;
      if (String(o) === String(current)) opt.selected = true;
      sel.appendChild(opt);
    });
    sel.addEventListener("change", (e) => onChange(e.target.value));
    wrap.appendChild(sel);
    return wrap;
  }

  _divider() {
    const d = document.createElement("div");
    d.className = "gt-divider";
    return d;
  }

  _toggleGridControls() {
    const isFit = this.data.style === "fit";
    [this._colsSel?.parentElement, this._rowsSel?.parentElement].forEach(
      (el) => {
        if (!el) return;
        el.classList.toggle("disabled", !isFit);
      },
    );
  }

  _renderGrid() {
    if (!this._gridEl) return;
    this._gridEl.innerHTML = "";

    if (!this.data.files.length) {
      const empty = document.createElement("div");
      empty.className = "gt-empty";
      empty.innerHTML = `
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
          <polyline points="21 15 16 10 5 21"/>
        </svg>
        <span>Зураг нэмээгүй байна</span>`;
      this._gridEl.appendChild(empty);
      return;
    }

    const cols = this.data.cols || 3;
    const maxVisible =
      this.data.rows > 0 ? cols * this.data.rows : this.data.files.length;
    const visible = this.data.files.slice(0, maxVisible);
    const hidden = this.data.files.length - visible.length;

    const grid = document.createElement("div");
    grid.className = "gt-grid";
    grid.style.gridTemplateColumns = `repeat(${cols}, 1fr)`;

    visible.forEach((file, idx) => {
      const cell = document.createElement("div");
      cell.className = "gt-cell";

      const img = document.createElement("img");
      img.src = file.url;

      const overlay = document.createElement("div");
      overlay.className = "gt-cell-overlay";

      // Edit button
      const edit = document.createElement("button");
      edit.className = "gt-overlay-btn gt-edit-btn";
      edit.type = "button";
      edit.title = "Тохиргоо";
      edit.innerHTML = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>`;
      edit.addEventListener("click", (e) => {
        e.stopPropagation();
        this._openEditModal(idx);
      });

      // Delete button
      const del = document.createElement("button");
      del.className = "gt-overlay-btn gt-del-btn";
      del.type = "button";
      del.title = "Устгах";
      del.innerHTML = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
      del.addEventListener("click", (e) => {
        e.stopPropagation();
        this.data.files.splice(idx, 1);
        this._renderGrid();
      });

      overlay.appendChild(edit);
      overlay.appendChild(del);
      cell.appendChild(img);
      cell.appendChild(overlay);

      // Caption at bottom
      if (file.caption) {
        const cap = document.createElement("div");
        cap.className = "gt-cell-caption";
        cap.textContent = file.caption;
        cell.appendChild(cap);
      }

      // Link icon indicator
      if (file.link) {
        const linkIcon = document.createElement("div");
        linkIcon.className = "gt-cell-link-icon";
        linkIcon.innerHTML = `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#3182ce" stroke-width="2.5"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>`;
        cell.appendChild(linkIcon);
      }

      // Click cell → navigate to link
      cell.addEventListener("click", () => {
        if (file.link) {
          window.open(file.link, "_blank", "noopener,noreferrer");
        }
      });

      grid.appendChild(cell);
    });

    if (hidden > 0) {
      const more = document.createElement("div");
      more.className = "gt-more";
      more.textContent = `+${hidden}`;
      grid.appendChild(more);
    }

    this._gridEl.appendChild(grid);
  }

  /* ── Edit Modal ──────────────────────────────────────── */
  _openEditModal(idx) {
    const file = this.data.files[idx];
    if (!file) return;

    const backdrop = document.createElement("div");
    backdrop.className = "gt-modal-backdrop";

    const modal = document.createElement("div");
    modal.className = "gt-modal";

    // Header
    const header = document.createElement("div");
    header.className = "gt-modal-header";
    header.innerHTML = `<span>Зургийн тохиргоо</span>`;
    const closeBtn = document.createElement("button");
    closeBtn.className = "gt-modal-close";
    closeBtn.type = "button";
    closeBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
    closeBtn.addEventListener("click", () => backdrop.remove());
    header.appendChild(closeBtn);

    // Body
    const body = document.createElement("div");
    body.className = "gt-modal-body";

    const preview = document.createElement("img");
    preview.className = "gt-modal-preview";
    preview.src = file.url;
    body.appendChild(preview);

    // Caption field
    const captionField = document.createElement("div");
    captionField.className = "gt-modal-field";
    captionField.innerHTML = `<label>Тайлбар (caption)</label>`;
    const captionInput = document.createElement("input");
    captionInput.type = "text";
    captionInput.placeholder = "Зургийн тайлбар бичнэ үү...";
    captionInput.value = file.caption || "";
    captionField.appendChild(captionInput);
    body.appendChild(captionField);

    // Link field
    const linkField = document.createElement("div");
    linkField.className = "gt-modal-field";
    linkField.innerHTML = `<label>Холбоос (URL)</label>`;
    const linkInput = document.createElement("input");
    linkInput.type = "url";
    linkInput.placeholder = "https://example.com";
    linkInput.value = file.link || "";
    linkField.appendChild(linkInput);
    body.appendChild(linkField);

    // Footer
    const footer = document.createElement("div");
    footer.className = "gt-modal-footer";

    const cancelBtn = document.createElement("button");
    cancelBtn.className = "gt-modal-btn";
    cancelBtn.type = "button";
    cancelBtn.textContent = "Болих";
    cancelBtn.addEventListener("click", () => backdrop.remove());

    const saveBtn = document.createElement("button");
    saveBtn.className = "gt-modal-btn primary";
    saveBtn.type = "button";
    saveBtn.textContent = "Хадгалах";
    saveBtn.addEventListener("click", () => {
      file.caption = captionInput.value.trim();
      file.link = linkInput.value.trim();
      this._renderGrid();
      backdrop.remove();
    });

    footer.appendChild(cancelBtn);
    footer.appendChild(saveBtn);

    modal.appendChild(header);
    modal.appendChild(body);
    modal.appendChild(footer);
    backdrop.appendChild(modal);

    backdrop.addEventListener("click", (e) => {
      if (e.target === backdrop) backdrop.remove();
    });

    document.body.appendChild(backdrop);
    captionInput.focus();
  }

  _pickFiles() {
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.accept = "image/*";
    input.addEventListener("change", async () => {
      for (const file of Array.from(input.files)) {
        const result = await this.config.uploader.uploadByFile(file);
        if (result.success)
          this.data.files.push({ url: result.file.url, caption: "", link: "" });
      }
      this._renderGrid();
    });
    input.click();
  }

  save() {
    return {
      files: this.data.files.map((f) => ({
        url: f.url,
        caption: f.caption || "",
        link: f.link || "",
      })),
      cols: this.data.cols,
      rows: this.data.rows,
      style: this.data.style,
      caption: this.data.caption,
    };
  }

  static validate(data) {
    return Array.isArray(data.files) && data.files.length > 0;
  }
}
